import React from 'react';
import { Row, Column, Icon } from '@upgrade/react-components';
import { mdiPhoneInTalkOutline } from '@mdi/js';
import { StyledSection } from './styles';
import { Section, CenteredContainer } from '../styles';
import Fluid from '../../Fluid';
import IconSupportEmail from '../../../img/icon-support-email.svg';

export default ({ contact: { mail, phone, days, hours, backgroundColor }, smallPadding, children }) => (
  <Section data-color={backgroundColor} borderless {...{ smallPadding }}>
    <Fluid>
      <Row smHorizontalAlign="center">
        <CenteredContainer style={{ paddingBottom: '2rem' }}>
          <Column xs={12}>
            <StyledSection className="section text--weight-medium">
              <div className="section--xs">
                <img src={IconSupportEmail} alt="" />
              </div>
              <a href={`mailto:${mail}`}>{mail}</a>
            </StyledSection>
            <StyledSection className="section text--weight-medium">
              <div className="section--xs">
                <Icon color="content" size="small" icon={mdiPhoneInTalkOutline} />
              </div>
              <p>{phone}</p>
              <p>{days}</p>
              <p>{hours}</p>
            </StyledSection>
          </Column>
          {children}
        </CenteredContainer>
      </Row>
    </Fluid>
  </Section>
);
